module.exports = __webpack_public_path__ + "img/beer_id-46.f2a73703.png";